import { render, staticRenderFns } from "./service-table.vue?vue&type=template&id=1d1541f0"
import script from "./service-table.vue?vue&type=script&lang=js"
export * from "./service-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports